import { CategoryTree } from '@lambda/apis/src/category/types';
import { Dispatch, SetStateAction } from 'react';

export enum SlideDirectionT {
  RIGHT = 'right',
  LEFT = 'left',
  NONE = '',
}

export type MainMenuViewT = 'menu' | 'country';

export interface ContentProps {
  history: string[];
  setHistory: Dispatch<SetStateAction<string[]>>;
  currentChildren: CategoryTree[];
  setCurrentChildren: Dispatch<SetStateAction<CategoryTree[]>>;
  currentParent: CategoryTree | null;
  setSlideDirection: Dispatch<SetStateAction<SlideDirectionT>>;
  closeMenu: () => void;
  onCountryClick: () => void;
}

export interface ContentWrapperProps {
  slideDirection: SlideDirectionT;
  viewKey: string;
  children: JSX.Element | null;
}

export interface BackButtonProps {
  history: string[];
  activeView: MainMenuViewT;
  onBackToMainMenuClick: () => void;
  onBackToParentClick: () => void;
  onBackToMenuFromCountry: () => void;
  parentName: string;
}

export interface HotDealsAndTrendingProps {
  closeMenu: () => void;
}
export interface ShopByDepartmentProps {
  history: string[];
  currentParent: CategoryTree | null;
  onClick: (item: CategoryTree) => void;
  currentChildren: CategoryTree[];
  closeMenu: () => void;
}

export interface LinkItemProps {
  title: string;
  handle: string;
  icon?: any;
  isSubMenu?: boolean;
  closeMenu: () => void;
  className?: string;
}

export interface ButtonItemProps {
  title: string;
  onClick: () => void;
  history: string[];
  subMenuItem: CategoryTree[];
  closeMenu: () => void;
}

export interface SettingsProps {
  closeMenu: () => void;
  onCountryClick: () => void;
}
